export default __webpack_public_path__ + "static/media/janelle.4dc55a73.jpg";